import axios from 'axios';
import { debounce } from 'debounce';
import { Dbx } from '../dbx';
import { db } from '../firebase/FireDataContext';

const query = postcode => {
    return new Promise(async (resolve, reject) => {
        try {
            const response = await axios.get(`https://api.postcodes.io/postcodes/${postcode}`);
            console.log('resolve', response)
            resolve({...response.data});
        } 
        catch (error) {
            reject(error);     
        }
    })
}

const reaction = async postcode => {
    if (!postcode) return;

    postcode = postcode.replace(/\s/gi, '');

    if (!postcode?.match(/[A-Z]{1,2}[0-9]{1,2}?[0-9][A-Z]{2}/i)) {
        return;
    }

    // TODO: move this to firestore 
    const cached = Dbx.read(postcode);
    if (cached) {
        console.log (postcode, 'found in local storage');
        Dbx.publish({topic: 'location-changed', value: postcode, durable: true});
        return;
    }

    query(postcode).then(({addresses, longitude, latitude}) => {
        const location = {
            postcode,
            geo: {
                longitude,
                latitude
            },
            addresses
        }

        Dbx.publish({topic: postcode, value: location, durable: true});
        Dbx.publish({topic: 'location-changed', value: postcode, durable: true});

        db.update({
            path: `postcodes/${postcode}`,
            payload: location
        });
    })
    .catch(error => {
        console.log(error);
    })
}

const PostcodeQueryReaction = {topic: 'postcode-change', hook: debounce(reaction, 500)};

const LocationAddressReaction = {
    topic: 'booking-location-change',
    hook: location => {
        const history = Dbx.read('address-history') || [];
        if (!history.find(item => item.address === location.address && item.postcode === location.postcode)) {
            history.push(location);
            Dbx.publish({topic: 'address-history', value: history, durable: true});
        }
    }
}

export {PostcodeQueryReaction, LocationAddressReaction}